import type { AxiosError } from 'axios';
import type { UseQueryResult } from 'react-query/types/react/types';

import { useApi } from 'hb-builder/api';
import type {
  FetchDynamicSearchArgs,
  FetchDynamicSearchByTypeArgs,
} from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch/types';
import { useSearchDiscussions } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch/useSearchDiscussions';
import { useSearchEvents } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch/useSearchEvents';
import { useSearchNews } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch/useSearchNews';
import { useSearchPosts } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch/useSearchPosts';
import { useSearchTopics } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch/useSearchTopics';
import { useSearchUsers } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch/useSearchUsers';

export const useGetDynamicSearch = <T = unknown,>({
  app,
  enabled = true,
  params,
  type,
  whiteLabelUrl,
}: FetchDynamicSearchArgs): UseQueryResult<T[], AxiosError> => {
  const { authenticationIds } = useApi();
  const { admin, network: networkId, topic, user: userId } = authenticationIds;

  const isOnWhiteLabelUrl = window.location.hostname === whiteLabelUrl;

  const ids = {
    admin_id: admin?.id,
    network_id: networkId,
    topic_id: !isOnWhiteLabelUrl ? topic : undefined,
    user_id: userId,
  };

  const fetchersArgs: FetchDynamicSearchByTypeArgs = {
    app,
    enabled,
    ids,
    networkId,
    params,
    type,
  };

  return {
    discussions: useSearchDiscussions(fetchersArgs),
    events: useSearchEvents(fetchersArgs),
    news: useSearchNews(fetchersArgs),
    topics: useSearchTopics(fetchersArgs),
    posts: useSearchPosts(fetchersArgs),
    users: useSearchUsers(fetchersArgs),
  }?.[type];
};
